import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CameraGridSVG = function CameraGridSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("rect", {
    x: "11.98",
    y: "12.01",
    width: "7.98",
    height: "7.98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "12.01",
    width: "7.98",
    height: "7.98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "11.98",
    y: "21.99",
    width: "7.98",
    height: "8.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,2H22v8h8V4A2,2,0,0,0,28,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,28a2,2,0,0,0,2,2h6V22H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30h6a2,2,0,0,0,2-2V22H22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,4v6h8V2H4A2,2,0,0,0,2,4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "11.98",
    y: "2",
    width: "7.98",
    height: "8.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "21.96",
    y: "12.01",
    width: "8.04",
    height: "7.98"
  }));
};
CameraGridSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CameraGridSVG);